import {getLinkPath} from 'app/utils/link_helper';

export const onCloseItemIntentory = (): void => {
    if (window.location.pathname.indexOf('/my_profile/hero') !== -1) {
        history.pushState({}, null, getLinkPath('/my_profile/hero'));
    }
};
